import moment from 'moment';

export const isSameDay = (a?: moment.Moment, b?: moment.Moment): boolean => {
  if (!moment.isMoment(a) || !moment.isMoment(b)) return false;
  return a.date() === b.date() && a.month() === b.month() && a.year() === b.year();
};
